import { Injectable } from '@angular/core';
import {Router} from '@angular/router';
import {Http, Response} from '@angular/http';
import {Observable} from 'rxjs/Observable';
import {ParentService} from '../A2-utils/ParentClass/ParentService';
import { constant } from '../../app.constants';
import { BehaviorSubject } from 'rxjs';

@Injectable()
export class RolesService extends ParentService {
  roleId = new BehaviorSubject<number>(null);
  roleId$ = this.roleId.asObservable();
  save = new BehaviorSubject<boolean>(false);
  save$ = this.save.asObservable();
  openModal = new BehaviorSubject<boolean>(false);
  openModal$ = this.openModal.asObservable();

  smartTableData = [];

  constructor(private _http: Http, private route: Router) {
    super();
    // this.verifyToken(this._http, route);
  }

  /**
   * @name getRole
   * @description
   */
  getRole() {
    return this._http
      .get(constant.URL_ROLE, this.getHeader())
      .map(res => res.json())
      .catch((error) => Observable.throw(error.json()));
  }

  /**
   * @name getRoleById
   * @description
   * @param id
   */
  getRoleById(id: number) {
    return this._http
      .get(constant.URL_ROLE + '/' + id, this.getHeader())
      .map(res => res.json());
  }

  /**
   * @name postData
   * @description
   * @param data
   */
  postData(data: any) {
    const bodyString = JSON.stringify(data);

    return this._http
      .post(constant.URL_ROLE, bodyString, this.headerPost())
      .map((res: Response) => res.json())
      .catch((error: any) => Observable.throw(error.json()));
  }

  /**
   * @name putData
   * @description
   * @param data
   */
  putData(data: any) {
    const bodyString = JSON.stringify(data);

    return this._http
      .put(constant.URL_ROLE, bodyString, this.headerPost())
      .map((res: Response) => res.json())
      .catch((error: any) => Observable.throw(error.json()));
  }

  /**
   * @name deleteData
   * @description
   * @param data
   */
  deleteData(data: any) {
    return this._http
      .delete(`${constant.URL_ROLE}/${data}`, this.headerPost())
      .map((res: Response) => res.json())
      .catch((error: any) => Observable.throw(error.json()));
  }

  /**
   * @name getRolActions
   * @description
   * @param data
   */
  getRolActions(data: any) {
    return this._http
      .get(constant.URL_ROLEACTIONS + data, this.getHeader())
      .map(res => res.json());
  }

  /**
   * @name getModuleActions
   * @description
   * @param data
   */
  getModuleActions(data: any) {
    return this._http
      .get(constant.URL_ACTION_BY_MODULE + '/' + data, this.getHeader())
      .map(res => res.json());
  }

  /**
   * @name postRoleAction
   * @param data
   */
  postRoleAction(data: any) {
    const bodyString = JSON.stringify(data);
    return this._http
      .post(constant.URL_ROLEACTIONCREATE, bodyString, this.headerPost())
      .map((res: Response) => res.json())
      .catch((error: any) => Observable.throw(error.json()));
  }

  /**
   * @name deleteDaRoleAction
   * @description
   * @param data
   */
  deleteDaRoleAction(data: any) {
    return this._http
      .delete(`${constant.URL_ROLEACTIONAPI}/${data}`, this.headerPost())
      .map((res: Response) => res.json())
      .catch((error) => Observable.throw(error.json()));
  }

  /**
   * @name getProviderRole
   * @description
   * @param roleId
   */
  getProviderRole(roleId: number) {
    return this._http
      .get(constant.PROVIDERROLE_LIST_BY_ROLE + roleId, this.getHeader())
      .map(res => res.json());
  }

  /**
   * @name postProviderRole
   * @description
   * @param data
   */
  postProviderRole(data: any) {
    const bodyString = JSON.stringify(data);

    return this._http
      .post(constant.PROVIDERROLE, bodyString, this.headerPost())
      .map((res: Response) => res.json())
      .catch((error) => Observable.throw(error.json()));
  }

  historyRol(id: number) {
    return this._http.get(`${constant.URL_ROLE}/${id}/History`, this.getHeader())
      .map(res => res.json())
      .catch((error) => Observable.throw(error.json()));
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/roles/roles.service.ts